import React, { useEffect, useRef, useState } from "react";
import FilterComponents from "../../../product/components/FilterComponents.tsx";
import CustomDataGrid from "../../../components/CustomDataGrid/CustomDataGrid.tsx";
import axios from "axios";
import jwt_decode from "jwt-decode";
import { Button, Grid, Switch } from "@mui/material";
import edit from "./../../../../assets/icons/edit.png";
import AddRestaurantDialog from "../AddRestaurantDialog/AddRestaurantDialog.tsx";
import EditEmployeeDialog from "../EditEmployeeDialog/EditEmployeeDialog.tsx";
import pencilIcon from "./../../../../assets/icons/editPencil.png";
import qrCode from "../../../../assets/icons/qr-code-icon.png";
import QrPdfComponent from "../../../QrCode/QrPdfComponent.tsx";
import scanner from "../../../../assets/icons/scanner.png";
import { Box, Modal, Typography } from "@mui/material";
import close from "../../../../assets/icons/close.png";
import html2pdf from "html2pdf.js";
import downloads from "../../../../assets/icons/downloads.png";
import RestaurantQrComponent from "../../../QrCode/RestaurantQrComponent.tsx";
import QRCode from "react-qr-code";
import SweetAlertModal from "../../../../pages/components/SweetAlertModal/SweetAlertModal.js";
import { toast } from "react-toastify";
import RestaurantUnavailableDialog from "./RestaurantUnavailableDialog.tsx";
import SubscriptionSetup from "../../../SubscriptionSetup/SubscriptionSetup.tsx";

function RestaurantSetupPage(props) {
  const [showQrModal, setShowQrModal] = useState(false);
  const [QrData, setQrData] = useState({});
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const downloadPdfRef = useRef(null);

  const [showSubscriptionComponent, setShowSubscriptionComponent] =
    useState(false);
  const [selectedSubRestaurantId, setSelectedSubRestaurantId] = useState(null);

  const apiAddress = process.env.REACT_APP_SECRET;
  const loadData = async () => {
    const token = localStorage.getItem("gotasteadmintoken");
    var decodedData = {};
    if (token != null) {
      try {
        decodedData = jwt_decode(token);

        var obj = {
          id: decodedData.UserId,
          title: decodedData.UserName,
        };
      } catch (error) {}
    }
    const restaurant = JSON.parse(localStorage.getItem("restaurant"));
    axios
      .get(
        apiAddress +
          "/api/Restaurant/getrestaurantdetailsbyidfortable/" +
          decodedData.UserId +
          "/" +
          restaurant.id,
      )
      .then((response) => {
        console.log(response.data);
        var list = [];
        // list.push(response.data)
        // setRestaurantDatas(list);
        response.data.map((dt, i) => {
          var obj = {
            id: dt.id,
            name: dt.name,
            address: dt.addressLine1,
            PhoneNumber: dt.phoneNumber,
            Email: dt.emailAddress,
            isActive: dt.isActive,
            isPreview: dt.isPreview,
            isHomeCook: dt.isHomeCookToggle,
            subscriptionPlanId: dt.subscriptionPlanId,
          };
          list.push(obj);
        });

        setDataRows(list);
      });
  };

  useEffect(() => {
    loadData();
  }, []);

  const generatePDF = (element) => {
    const opt = {
      margin: 1,
      filename: "QrCode.pdf",
      image: { type: "jpeg", quality: 0.98 },
      html2canvas: { scale: 2, useCORS: true },
      jsPDF: { unit: "mm", format: "letter", orientation: "portrait" },
    };

    html2pdf().from(element).set(opt).save();
  };

  const handleDownloadPdf = () => {
    const element: any = downloadPdfRef.current;

    if (!element) {
      console.error("Element reference not found.");
      return;
    }

    const logoImage = element.querySelector(".restaurant-logo img");

    if (logoImage && !logoImage.complete) {
      // Ensure the logo is fully loaded
      logoImage.onload = () => {
        generatePDF(element);
      };
    } else {
      generatePDF(element);
    }
  };

  const handleGenerateQrCode = async (row) => {
    setShowQrModal(true);
    try {
      setError("");
      setLoading(true);
      const response = await axios.get(
        `${process.env.REACT_APP_SECRET}/api/Restaurant/getrestaurantdetailsbyidforedit/${row.id}`,
      );

      console.log("clicked row: ", response.data.restaurantView);
      setQrData(response?.data?.restaurantView);
      setLoading(false);
    } catch (error) {
      setError(error.response.data);
      setLoading(false);
      console.log(error);
    }
  };

  const getPreviewSwitchProps = (row) => {
    const isHomeCook = row.isHomeCook === true;
    const subId = row.subscriptionPlanId;

    // Normal Restaurant (IsHomeCookToggle = 0)
    if (!isHomeCook) {
      return {
        checked: row.isPreview,
        disabled: false,
        onChange: (e) => handlePreviewToggleChange(e, row),
      };
    }

    // Home Cook Restaurant (IsHomeCookToggle = 1)
    if (isHomeCook) {
      // If no subscription active
      if (!subId) {
        return {
          checked: true, // Toggle ON
          disabled: true, // Disabled
          onChange: () => {}, // No action
        };
      }

      // If Basic Subscription
      // If Premium (any other ID), the logic below also applies (Off and Enabled)
      return {
        checked: false, // Toggle OFF
        disabled: false, // Enabled
        onChange: (e) => handlePreviewToggleChange(e, row),
      };
    }

    // Fallback
    return {
      checked: row.isPreview,
      disabled: false,
      onChange: (e) => handlePreviewToggleChange(e, row),
    };
  };

  const getSubscriptionButtonProps = (row) => {
    const isHomeCook = row.isHomeCook === true;
    const subId = row.subscriptionPlanId;

    // Normal Restaurant: Pay button don't show
    if (!isHomeCook) {
      return { show: false };
    }

    // Home Cook Restaurant
    if (isHomeCook) {
      // No subscription: Show enabled Upgrade button
      if (!subId) {
        return {
          show: true,
          disabled: false,
          label: "Upgrade",
          onClick: () => {
            setSelectedSubRestaurantId(row.id);
            setShowSubscriptionComponent(true);
          },
        };
      }

      // Basic Subscription ("4"): Show enabled Upgrade button
      if (subId === 4) {
        return {
          show: true,
          disabled: false,
          label: "Upgrade",
          onClick: () => {
            setSelectedSubRestaurantId(row.id);
            setShowSubscriptionComponent(true);
          },
        };
      }

      // Premium Subscription: Show disabled button
      return {
        show: true,
        disabled: true,
        label: "Premium Active",
        onClick: () => {},
      };
    }

    return { show: false };
  };

  const columns = [
    {
      field: "name",
      headerName: "Name",
      align: "center",
      renderCell: (params) => (
        <div
          className="d-flex align-items-center justify-content-center"
          style={{ gap: "5px", cursor: "pointer" }}
          onClick={() => {
            selectDataForEdit(params.value);
            setOpen(true);
          }}
        >
          <span style={{ color: "blue", cursor: "pointer" }}>
            {params.value}{" "}
          </span>
          <img src={pencilIcon} alt="" style={{ width: ".8rem" }} />
        </div>
      ),
      headerAlign: "center",
      flex: 1,
    },
    {
      field: "address",
      headerName: "Address",
      align: "center",
      headerAlign: "center",
      flex: 1,
    },
    {
      field: "PhoneNumber",
      headerName: "PhoneNumber",
      align: "center",
      headerAlign: "center",
      flex: 1,
    },
    {
      field: "Email",
      headerName: "Email",
      align: "center",
      headerAlign: "center",
      flex: 1,
    },
    {
      field: "isActive",
      headerName: "Availability",
      align: "center",
      headerAlign: "center",
      flex: 0.5,
      renderCell: (params) => (
        <Switch
          checked={params.value}
          onChange={(event) => handleToggleChange(event, params.row)}
          color="primary"
          inputProps={{ "aria-label": "toggle" }}
          id={params.row.id}
        />
      ),
    },
    {
      field: "isPreview",
      headerName: "Preview",
      align: "center",
      headerAlign: "center",
      flex: 0.5,
      renderCell: (params) => {
        const props = getPreviewSwitchProps(params.row);

        return (
          <Switch
            checked={props.checked}
            disabled={props.disabled}
            onChange={props.onChange}
            color="primary"
            inputProps={{ "aria-label": "preview toggle" }}
          />
        );
      },
    },
    {
      field: "subscriptionAction",
      headerName: "Subscription",
      align: "center",
      headerAlign: "center",
      flex: 1,
      renderCell: (params) => {
        // Use the helper function we created
        const btnProps = getSubscriptionButtonProps(params.row);

        // If show is false, return empty or a dash
        if (!btnProps.show) {
          return <span>-</span>;
        }

        return (
          <Button
            variant="contained"
            color="primary"
            size="small"
            disabled={btnProps.disabled}
            onClick={btnProps.onClick}
            sx={{
              backgroundColor: btnProps.disabled ? "#ccc" : undefined,
              "&:hover": {
                backgroundColor: btnProps.disabled ? "#ccc" : undefined,
              },
            }}
          >
            {btnProps.label}
          </Button>
        );
      },
    },
    {
      headerName: "Action",
      align: "center",
      headerAlign: "center",
      renderCell: (params) => (
        <div
          className="d-flex align-items-center justify-content-center printer-icon"
          style={{ gap: "5px", cursor: "pointer" }}
          onClick={() => handleGenerateQrCode(params.row)}
          title="Generate QR code"
        >
          <img src={qrCode} alt="qr code icon" />
        </div>
      ),
    },
  ];

  const [enableOptions, setEnableOptions] = React.useState(false);
  const [dataRows, setDataRows] = useState([]);
  const [selectedDatas, setselectedDatas] = useState();

  const [selectedRowId, setSelectedRowId] = useState(null);
  const [openRestaurantUnavailableDialog, setOpenRestaurantUnavailableDialog] =
    useState(false);
  const [openRestaurantAvailableDialog, setOpenRestaurantAvailableDialog] =
    useState(false);

  const handleToggleChange = (event, id) => {
    console.log("active", id);
    if (id.isActive == false) {
      setSelectedRowId(id.id);
      setOpenRestaurantAvailableDialog(true);
    } else {
      setOpenRestaurantUnavailableDialog(true);
      setSelectedRowId(id.id);
    }
  };

  const handlePreviewToggleChange = async (event, row) => {
    // Prevent the switch from updating immediately if we want to wait for API confirmation,
    // or update optimistically. Here we'll call the API first.
    const newStatus = !row.isPreview;

    try {
      // Assuming there is an endpoint to update preview status.
      // You might need to adjust the URL and method based on your backend API.
      // Example: PUT /api/Restaurant/UpdatePreviewStatus?Id=123&Status=true
      await axios({
        method: "put",
        url: `${apiAddress}/api/Restaurant/UpdatePreviewStatus?Id=${row.id}&Status=${newStatus}`,
      });

      toast.success(
        `Preview status updated to ${newStatus ? "Enabled" : "Disabled"}`,
        {
          position: "top-right",
          autoClose: 3000,
          theme: "colored",
        },
      );

      // Reload data to reflect the change from the server
      loadData();
    } catch (error) {
      console.error("Error updating preview status:", error);
      toast.error("Failed to update preview status", {
        position: "top-right",
        autoClose: 3000,
        theme: "colored",
      });
    }
  };

  const RestaurantActivate = () => {
    console.log(selectedRowId);

    if (selectedRowId != undefined) {
      axios({
        method: "put",
        url:
          apiAddress +
          "/api/Restaurant/SetRestaurantAvailable?restaurantId=" +
          selectedRowId,
      }).then((response) => {
        toast.success("Restaurant activated", {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "colored",
        });
        loadData();
      });
    }
    setOpenRestaurantAvailableDialog(false);
  };

  const RestaurantDeactivate = () => {
    console.log(selectedRowId);

    if (selectedRowId != undefined) {
      axios({
        method: "put",
        url:
          apiAddress +
          "/api/Restaurant/RestaurantActiveStatusChange?Id=" +
          selectedRowId +
          "&Status=" +
          false,
      }).then((response) => {
        toast.success("Restaurant set to Unavailable", {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "colored",
        });
        loadData();
      });
    }
    setOpenRestaurantUnavailableDialog(false);
  };

  const selectDataForEdit = (props) => {
    console.log(props);
    console.log(dataRows);
    var obj = dataRows.find((x) => x.name == props);
    console.log(obj);
    setselectedDatas(obj.id);
  };

  const getselectedData = (props) => {
    var temp = props;
    if (props == "") {
      setEnableOptions(false);
    } else {
      setselectedDatas(props);
      setEnableOptions(true);
    }
  };

  const [open, setOpen] = React.useState(false);

  const openSetupModal = () => {
    setOpen(true);
  };
  const handleAddItem = (AddItemData) => {
    setOpen(AddItemData);
    setOpenRestaurantUnavailableDialog(AddItemData);
  };

  return (
    <div>
      <FilterComponents title={"OK"} isItem={1} />
      <SweetAlertModal
        headerText={"Are you sure?"}
        bodyText={"This action will make this restaurant available"}
        open={openRestaurantAvailableDialog}
        onyes={RestaurantActivate}
        close={() => {
          setOpenRestaurantAvailableDialog(false);
        }}
      />

      {showSubscriptionComponent ? (
        // VIEW 1: Show Subscription Setup Component when button is clicked
        <Box sx={{ mt: 4, ml: 2 }}>
          {/* Back Button to return to the list */}
          <Button
            variant="outlined"
            startIcon={<img src={close} alt="back" style={{ width: "1rem" }} />}
            onClick={() => {
              setShowSubscriptionComponent(false);
              setSelectedSubRestaurantId(null);
            }}
            sx={{ mb: 3 }}
          >
            Back to Restaurant List
          </Button>

          {/* Render the Subscription Setup Component */}
          <SubscriptionSetup initialRestaurantId={selectedSubRestaurantId} />
        </Box>
      ) : (
        // VIEW 2: Show the Original Table/Grid View (Default)
        <>
          <Grid
            container
            alignItems="center"
            justifyContent="space-between"
            mt={2}
            mb={2}
          >
            <Grid item>
              <Grid container spacing={2} alignItems="center">
                {/* Your existing empty/commented out Grid items can stay here */}
              </Grid>
            </Grid>
            <Grid item>
              {/* Your existing empty/commented out Grid items can stay here */}
            </Grid>
          </Grid>

          {dataRows.length > 0 ? (
            <CustomDataGrid
              columns={columns}
              dataRows={dataRows}
              getselectedData={getselectedData}
            />
          ) : (
            <p>Nothing found</p>
          )}
        </>
      )}

      {open ? (
        <EditEmployeeDialog
          open={open}
          onHandleAddItem={handleAddItem}
          title={props.title}
          isEdit={"true"}
          selectedId={selectedDatas}
        />
      ) : (
        ""
      )}

      {openRestaurantUnavailableDialog && (
        <RestaurantUnavailableDialog
          open={openRestaurantUnavailableDialog}
          selectedMenuId={selectedRowId}
          onHandleAddItem={handleAddItem}
        />
      )}

      <Modal
        open={showQrModal}
        onClose={() => setShowQrModal(false)}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box className="modal-wrapper">
          <Typography
            className="header-wrapper"
            id="modal-modal-title"
            variant="h6"
            component="h2"
          >
            <div>QR code</div>
            <div className="close-btn" onClick={() => setShowQrModal(false)}>
              <img src={close} alt="close button" />
            </div>
          </Typography>
          <Typography id="modal-modal-description" sx={{ mt: 2 }}>
            {loading ? (
              <div>Generating Qr code...</div>
            ) : (
              <QrPdfComponent
                scanner={scanner}
                data={QrData}
                componentRef={downloadPdfRef}
                isTableQr={false}
              />
            )}
          </Typography>
          <div className="table-btn-group">
            <button
              className="table-setup-btn table-setup-close-btn"
              onClick={() => setShowQrModal(false)}
            >
              Close
            </button>

            <button
              className="table-setup-btn download-button"
              onClick={handleDownloadPdf}
            >
              <span>Download as pdf</span>
              <span className="download-icon">
                <img src={downloads} alt="download icon" />
              </span>
            </button>
          </div>
        </Box>
      </Modal>
    </div>
  );
}

export default RestaurantSetupPage;
